/**
 * Centralized style constants for the Welcome page
 * Reduces duplication and ensures consistency across components
 */

// Typography Styles
export const TYPOGRAPHY_STYLES = {
  // Header styles
  sectionHeader: {
    fontSize: 20,
    fontWeight: 500,
    color: "#009E77"
  } as const,

  cardHeader: {
    fontSize: 20,
    fontWeight: 400,
    color: "#009E77"
  } as const,

  // Body text styles
  body: {
    fontSize: 14,
    color: "#666",
    lineHeight: 1.4
  } as const,

  bodyBold: {
    fontSize: 14,
    color: "#333",
    fontWeight: 500
  } as const,

  // Card description with text clipping
  cardDescription: {
    fontSize: 14,
    color: "#666",
    lineHeight: 1.4,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    marginBottom: 0
  } as const
};

// Link Styles
export const LINK_STYLES = {
  // Standard link with hover underline
  standard: {
    fontSize: 14,
    color: "#009E77",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  } as const,

  // Card wrapper link (no decoration)
  cardWrapper: {
    textDecoration: "none",
    display: "block",
    color: "inherit",
    "& .application-icon svg": { color: "white" },
    boxShadow: "none",
    outline: "none",
    "&:hover": {
      color: "inherit",
      textDecoration: "none",
      boxShadow: "none",
      outline: "none"
    },
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    },
    "&:active": {
      color: "inherit"
    },
    "&:visited": {
      color: "inherit"
    }
  } as const
};

// Container/Box Styles
export const CONTAINER_STYLES = {
  // Flex row with centered alignment
  flexRowCenter: {
    display: "flex",
    alignItems: "center"
  } as const,

  // Flex row with centered alignment and gap
  flexRowCenterGap: {
    display: "flex",
    alignItems: "center",
    gap: "6px"
  } as const,

  // Flex column layout
  flexColumn: {
    display: "flex",
    flexDirection: "column"
  } as const,

  // Flex column with gap
  flexColumnGap: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  } as const,

  // Flex wrap for card grids
  flexWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px"
  } as const,

  // Support contacts details container
  supportDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginLeft: "48px"
  } as const
};

// Card Icon Box Styles
export const ICON_BOX_STYLES = {
  base: {
    color: "#FFFFFF",
    padding: "4px",
    height: 24,
    width: 24,
    borderRadius: "3px",
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "content-box"
  } as const
};
